import { readCookie, setCookie } from '../helpers/cookie.helper';
import { CMPData } from './consent-manager.types';

declare global {
    interface Window {
        cmp_id: string;
        cmp_cdid: string;
        et_seg1?: string;
        et_seg1_store?: string;
    }
}

declare let __cmp;

export class ConsentManager {
    private static instance: ConsentManager;
    private alreadyLoaded = false;

    // set constructor to private for singleton use
    private constructor() {
        if (readCookie('sewtracking') !== 'yes') {
            setCookie('sewtracking', 'no');
        }
    }

    public static getInstance(): ConsentManager {
        if (!ConsentManager.instance) {
            ConsentManager.instance = new ConsentManager();
        }

        return ConsentManager.instance;
    }

    public loadConsentManager(cmpId: string, cmpSrc: string): void {
        if (this.alreadyLoaded) {
            return;
        }

        if (isNaN(Number(cmpId))) {
            window.cmp_cdid = cmpId;
        } else {
            window.cmp_id = cmpId;
        }
        const head = document.getElementsByTagName('head')[0];
        const script = document.createElement('script');
        script.src = cmpSrc;

        script.onload = () => {
            try {
                __cmp('addEventListener', ['consent', this.updateSewTracking, false], null);
                __cmp('addEventListener', ['liestablished', this.updateSewTracking, false], null);
            } catch (error) {
                console.log('__cmp not found for script url: ', cmpSrc);
                console.log(error);
            }
        };

        head.insertBefore(script, head.firstChild);
        this.alreadyLoaded = true;
    }

    private getVendorConsent(vendor: string): boolean {
        const cmpData: CMPData = __cmp('getCMPData');
        if ('vendorConsents' in cmpData) {
            if (vendor in cmpData.vendorConsents && cmpData.vendorConsents[vendor]) {
                return true;
            }
        }
        return false;
    }

    private updateSewTracking = (): void => {
        // react to vendor: ETracker = s987
        if (this.getVendorConsent('s987')) {
            window.et_seg1 = window.et_seg1_store;
        } else {
            window.et_seg1 = undefined;
        }

        // react to vendor: SEW = c2352
        if (this.getVendorConsent('c2352')) {
            setCookie('sewtracking', 'yes');
        } else {
            setCookie('sewtracking', 'no');
            setCookie('sew-trackid', null);
        }

        // react to vendor: YouTube = s30
        if (this.getVendorConsent('s30')) {
            setCookie('youtube-opt-in', 'true');
            window.dispatchEvent(new Event('consentSet'));
        } else {
            setCookie('youtube-opt-in', null);
        }

        // react to vendor: Google = s1
        if (this.getVendorConsent('s1')) {
            setCookie('googlemaps-opt-in', 'true');
            window.dispatchEvent(new Event('consentSet'));
        } else {
            setCookie('googlemaps-opt-in', null);
        }
    };
}
